import React, { useRef, useState, useCallback } from "react";
import Image from "next/image";
import Modal from "react-bootstrap/Modal";
import styles from "../../styles/giftcard.module.scss";
import Cropper from "react-easy-crop";
import { getCroppedImg, getRotatedImage } from "./canvasUtils"; // same as demo
import { getOrientation } from "get-orientation/browser";

const ORIENTATION_TO_ANGLE: any = {
  3: 180,
  6: 90,
  8: -90,
};

const UploadSection: React.FC<any> = ({ indexFile, setUploadFile }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("");
  const [showModal2, setShowModal2] = useState(false);

  // cropper states
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [croppedImg, setCroppedImg] = useState<any>(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const onCropComplete = useCallback((_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      if (!imageSrc || !croppedAreaPixels) return;
      const croppedImg = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation
      );
      setCroppedImg({ ...croppedImg, indexFile });
      setCroppedImage(croppedImg.preview);
    } catch (e) {
      console.error(e);
    }
  }, [imageSrc, croppedAreaPixels, rotation, indexFile]);

  const handleFileChange = async (e: any) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);

    let imageDataUrl = await readFile(file);

    try {
      const orientation = await getOrientation(file);
      const rotate = ORIENTATION_TO_ANGLE[orientation];
      if (rotate) {
        imageDataUrl = await getRotatedImage(imageDataUrl, rotate);
      }
    } catch (err) {
      console.warn("Orientation detection failed");
    }

    setImageSrc(imageDataUrl as string);
    setShowModal2(true);
    setCroppedImage(null);
  };

  return (
    <div className={styles.uploadWrapper}>
      <button
        key={indexFile}
        type="button"
        onClick={handleClick}
        className={styles.uploadBtn}
      >
        Upload Photo
        <span className={styles.icon}>⬆</span>
      </button>

      <input
        key={indexFile}
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      {/* {fileName[indexFile] && (
        <p className={styles.fileName}>{fileName[indexFile]}</p>
      )} */}

      <Modal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        centered
        scrollable
        size="lg"
        className={styles.custom_modal_img_prev}
      >
        <Modal.Header closeButton className={styles.crop_modal_header}></Modal.Header>
        <Modal.Body className="p-4 pt-0">
          <div className="text-center mb-3 pt-4" style={{ color: '#ff1932', fontSize: '16px' }}>
            Drag the corner or your photo to adjust
          </div>
          <div className="row">
            <div className="col-md-7">
              <label style={{ fontWeight: 500, marginBottom: '10px', display: 'block' }}>Image:</label>
              <div style={{ position: 'relative', width: '100%', height: '350px', background: '#333' }}>
                {imageSrc && (
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    rotation={rotation}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                )}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="d-flex align-items-center flex-grow-1 me-4">
                  <label className="me-3 mb-0 text-muted" style={{ fontWeight: 500 }}>Zoom</label>
                  <input
                    type="range"
                    min="1"
                    max="3"
                    step="0.1"
                    value={zoom}
                    onChange={(e) => setZoom(parseFloat(e.target.value))}
                    className="form-range flex-grow-1"
                    style={{ accentColor: '#0d6efd' }}
                  />
                </div>
                <button
                  type="button"
                  className="btn text-white px-4 py-2"
                  style={{ backgroundColor: '#ea00b8', borderRadius: '6px', fontWeight: 600, border: 'none' }}
                  onClick={async () => {
                    try {
                      if (!imageSrc || !croppedAreaPixels) return;
                      const croppedImg = await getCroppedImg(
                        imageSrc,
                        croppedAreaPixels,
                        rotation
                      );
                      setUploadFile({
                        ...croppedImg,
                        indexFile,
                        preview: croppedImg.preview,
                      });
                      setShowModal2(false);
                    } catch (e) {
                      console.error(e);
                    }
                  }}
                >
                  Continue
                </button>
              </div>
            </div>

            <div className="col-md-5 ps-md-4 mt-4 mt-md-0">
              <div className="mb-4">
                <label style={{ fontWeight: 500, marginBottom: '10px', display: 'block' }}>Preview :</label>
                <div className="text-muted" style={{ fontSize: '15px' }}>
                  No preview yet
                </div>
              </div>
              <hr style={{ borderColor: '#ddd', margin: '20px 0' }} />
              <div>
                <h5 style={{ fontSize: '18px', color: '#333', marginBottom: '15px', fontWeight: 400 }}>Image Guidelines</h5>
                <ul className="text-muted ps-3" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  <li className="mb-2">Select an image of 550×550 pixels. Or</li>
                  <li className="mb-2">
                    You can select a picture from Facebook or Instagram
                    profile.
                  </li>
                  <li>Crop and save the image</li>
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UploadSection;

// helper
function readFile(file: File) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}
